import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import axios from "../lib/AxiosGo";
import { toast } from "react-toastify";

const BotPage = () => {
  const closeBtn = document.querySelector(
    '.btn-close[data-bs-dismiss="modal"]'
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    iteration: 0,
    chat: "",
    chooses: [],
    saveTo: "",
    type: "",
  });
  const [chooseKeyword, setChooseKeyword] = useState("");
  const [chooseChat, setChooseChat] = useState("");
  const [chooseTipe, setChooseTipe] = useState("");
  const [messageNext, setMessageNext] = useState("");
  const [chooseStatus, setChooseStatus] = useState("");
  const [messageStop, setMessageStop] = useState("");

  const [chooseData, setChooseData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const getData = async () => {
    try {
      const response = await axios.get("/bots/data");
      setData(response.data);
    } catch (error) {
      console.error("Error fetching bot data:", error);
    }
  };
  const handleClose = () => {
    setModalOpen(false);
  };
  const addBot = async () => {
    formData.chooses = chooseData; // Pastikan chooses adalah array sebelum submit

    axios
      .post("/bots/store", formData)
      .then((response) => {
        console.log("Bot added successfully:", response.data);
        getData(); // Refresh the bot list
        setFormData({ iteration: 0, chat: "" });
        if (closeBtn) {
          closeBtn.click();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          toast.error(error.response.data.error);
        }
      });
  };
  const handleDelete = async (botId) => {
    try {
      await axios.delete(`/bots/${botId}`);
      getData(); // Refresh the bot list
    } catch (error) {
      console.error("Error deleting bot:", error);
    }
  };
  const handleEdit = (row) => {
    let chooses = row.Chooses.map((choose) => ({
      keyword: choose.keyword,
      chat: choose.message,
      tipe: choose.tipe,
      messageNext: choose.messageNext,
      status: choose.status,
      messageStop: choose.messageStop,
    }));

    setFormData({
      id: row.id,
      iteration: row.iteration,
      chat: row.chat,
      chooses: chooses || [],
      type: row.type.key,
      saveTo: row.saveTo || "",
    });
    setTimeout(() => {
      setChooseData(chooses);
      setIsEdit(true);
    }, 1000);
  };
  const handleUpdate = (bot_id) => {
    formData.chooses = chooseData; // Pastikan chooses adalah array sebelum submit

    axios.put(`/bots/${bot_id}`, formData).then((response) => {
      toast.success("Bot updated successfully!");
      getData(); // Refresh the bot list
      setFormData({ bot_name: "", bot_number: "" });
      setIsEdit(false);
      if (closeBtn) {
        closeBtn.click();
      }
    });
  };

  useEffect(() => {
    if (!modalOpen) {
      const closeBtn = document.querySelector(
        '.btn-close[data-bs-dismiss="modal"]'
      );
      closeBtn.click();
    }
  }, [modalOpen]);
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Bot Page" />
        <div className="card h-100 radius-12">
          <div className="card-header py-16 px-24 bg-base d-flex align-items-center gap-1 justify-content-between border border-end-0 border-start-0 border-top-0">
            <h5 className="card-title text-lg text-primary-light mb-6">
              Bot Information
            </h5>
            <Link
              to="#"
              className="btn btn-primary-600 px-12 py-10 d-inline-flex align-items-center gap-2"
              onClick={() => {
                setIsEdit(false);
                setFormData({ iteration: 0, chat: "", type: "", chooses: [] });
                setChooseData([]);
              }}
              data-bs-toggle="modal"
              data-bs-target="#addBotModal"
            >
              <Icon
                icon="iconamoon:sign-plus-circle-duotone"
                className="text-xl"
              />{" "}
              Add Bot
            </Link>
          </div>
          <div className="card-body p-16">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table vertical-striped-table mb-0"
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "60px", textAlign: "center" }}>
                      Iteration
                    </th>
                    <th style={{ width: "350px" }}>Chat</th>
                    <th style={{ width: "120px" }}>Type Answer</th>
                    <th style={{ width: "120px" }}>Choose</th>
                    <th style={{ width: "120px" }}>Save To</th>
                    <th style={{ width: "180px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((bot) => (
                      <tr key={bot.id}>
                        <td
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "pre-line",
                            textAlign: "center",
                          }}
                        >
                          {bot.iteration}
                        </td>
                        <td
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {bot.chat}
                        </td>
                        <td
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {bot.type.label}
                        </td>
                        <td
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {Array.isArray(bot.Chooses) &&
                          bot.Chooses.length > 0 ? (
                            <ul className="mb-0 ps-3">
                              {bot.Chooses.slice()
                                .sort((a, b) => {
                                  if (a.keyword < b.keyword) return -1;
                                  if (a.keyword > b.keyword) return 1;
                                  return 0;
                                })
                                .map((choose, idx) => (
                                  <li key={idx}>
                                    <strong>{choose.keyword}.</strong>{" "}
                                    {choose.message}
                                  </li>
                                ))}
                            </ul>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {
                                bot.saveTo == "reporter-full_name"
                                    ? "Pelapor | Nama Lengkap"
                                : bot.saveTo == "reporter-gender"
                                    ? "Pelapor | Jenis Kelamin"
                                : bot.saveTo == "reporter-phone"
                                    ? "Pelapor | No Telepon"
                                : bot.saveTo == "reporter-address"
                                    ? "Pelapor | Alamat"
                                : bot.saveTo == "report-type_of_crime"
                                    ? "Jenis Tindak Pidana"
                                : bot.saveTo == "report-case"
                                    ? "Kasus"
                                : bot.saveTo == "report-location"
                                    ? "Lokasi"
                                : bot.saveTo == "report-victim_name"
                                    ? "Nama Korban"
                                : bot.saveTo == "report-gender"
                                    ? "Jenis Kelamin Korban"
                                : bot.saveTo == "report-victim_age"
                                    ? "Usia Korban"
                                : bot.saveTo == "report-victim_relation"
                                    ? "Hubungan Korban"
                                : bot.saveTo == "report-identity_perpetrator"
                                    ? "Identitas Pelaku"
                                : bot.saveTo == "report-attachment"
                                    ? "Lampiran"
                                : bot.saveTo == "report-further_approval"
                                    ? "Persetujuan Dimintai Lebih Lanjut"
                                : bot.saveTo == "report-agreement_reporter"
                                    ? "Persetujuan Pelapor"
                                : "-"
                            }
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary d-inline-flex align-items-center gap-2 me-2"
                            title="Edit"
                            onClick={() => {
                              handleEdit(bot);
                              setChooseData(bot.chooses || []);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#addBotModal"
                          >
                            <Icon icon="iconamoon:edit-fill" /> Edit
                          </button>
                          <button
                            className="btn btn-sm btn-danger d-inline-flex align-items-center gap-2 me-2"
                            onClick={() => handleDelete(bot.id)}
                            title="Delete"
                          >
                            <Icon icon="iconamoon:trash-fill" /> Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No bots found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className="modal fade"
              id="addBotModal"
              tabIndex="-1"
              aria-labelledby="addBotModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-fullscreen">
                <div className="modal-content radius-12">
                  <div className="modal-header">
                    <h5 className="modal-title" id="addBotModalLabel">
                      {isEdit ? "Edit" : "Add"} Bot
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label htmlFor="iteration" className="form-label">
                        Iteration
                      </label>
                      <input
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            iteration: e.target.value,
                          })
                        }
                        value={formData.iteration}
                        type="number"
                        min={1}
                        className="form-control"
                        id="iteration"
                        placeholder="Enter iteration"
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="chat" className="form-label">
                        Chat
                      </label>
                      <textarea
                        onChange={(e) =>
                          setFormData({ ...formData, chat: e.target.value })
                        }
                        value={formData.chat}
                        rows={10}
                        className="form-control"
                        id="chat"
                      >
                        {formData.chat}
                      </textarea>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="type" className="form-label">
                        Type
                      </label>
                      <select
                        onChange={(e) =>
                          setFormData({ ...formData, type: e.target.value })
                        }
                        value={formData.type || ""}
                        className="form-select"
                        id="type"
                      >
                        <option value="">Select type</option>
                        <option value="text">Text</option>
                        <option value="attachment">Attachment</option>
                        <option value="choose">Choose</option>
                        <option value="closed">Closed</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="type" className="form-label">
                        Simpan ke
                      </label>
                      <select
                        onChange={(e) =>
                          setFormData({ ...formData, saveTo: e.target.value })
                        }
                        value={formData.saveTo || ""}
                        className="form-select"
                        id="saveTo"
                      >
                        <option value="">Tidak ada</option>
                        <option value="reporter-full_name">
                          Pelapor | Nama Lengkap
                        </option>
                        <option value="reporter-gender">
                          Pelapor | Jenis Kelamin
                        </option>
                        <option value="reporter-phone">
                          Pelapor | No Telepon
                        </option>
                        <option value="reporter-address">
                          Pelapor | Alamat
                        </option>
                        <option value="report-type_of_crime">
                          Jenis Tindak Pidana
                        </option>
                        <option value="report-case">Kasus</option>
                        <option value="report-location">Lokasi</option>
                        <option value="report-victim_name">Nama Korban</option>
                        <option value="report-victim_age">Usia Korban</option>
                        <option value="report-gender">Jenis Kelamin Korban</option>
                        <option value="report-supporting_evidence">Bukti Pendukung</option>
                        <option value="report-victim_relation">
                          Hubungan Korban
                        </option>
                        <option value="report-identity_perpetrator">
                          Identitas Pelaku
                        </option>
                        <option value="report-attachment">Lampiran</option>
                        <option value="report-further_approval">
                          Persetujuan Dimintai Lebih Lanjut
                        </option>
                        <option value="report-agreement_reporter">
                          Persetujuan Pelapor
                        </option>
                      </select>
                    </div>
                    {formData.type === "choose" && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">Pilihan</label>
                          <div className="input-group mb-3">
                            <input
                              type="text"
                              className="form-control"
                              value={chooseKeyword || ""}
                              onChange={(e) => setChooseKeyword(e.target.value)}
                              placeholder="Tulis Kata Kunci"
                              style={{ maxWidth: "150" }}
                            />
                            <span className="input-group-text">
                              <Icon icon="mdi:arrow-right" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Tulis Jawaban"
                              value={chooseChat || ""}
                              onChange={(e) => setChooseChat(e.target.value)}
                            />
                            <select
                              className="form-select"
                              onChange={(e) => setChooseTipe(e.target.value)}
                              style={{ maxWidth: "200px" }}
                              value={chooseTipe}
                            >
                              <option value="">Jenis Jawaban</option>
                              <option value="keyword">Sesuai Kata Kunci</option>
                              <option value="text">Sesuai Pesan</option>
                              <option value="attachment">Sesuai Dokumen</option>
                            </select>
                            <select
                              className="form-select"
                              onChange={(e) => setChooseStatus(e.target.value)}
                              style={{ maxWidth: "200px" }}
                              value={chooseStatus}
                            >
                              <option value="">Status</option>
                              <option value="next">Lanjut</option>
                              <option value="stop">Berhenti</option>
                              <option value="loop">Kembali</option>
                            </select>
                            <button
                              type="button"
                              className="btn btn-success btn-sm mt-2"
                              onClick={() => {
                                const keywordVal = chooseKeyword.trim();
                                if (
                                  chooseData.some(
                                    (opt) => opt.keyword === keywordVal
                                  )
                                ) {
                                  toast.error("Keyword sudah ada di pilihan!");
                                  return false;
                                }
                                if (!keywordVal) {
                                  toast.error("Kata Kunci Wajib di isi!");
                                  return false;
                                }
                                if (!chooseTipe) {
                                  toast.error("Jenis Jawaban Wajib di isi!");
                                  return false;
                                }
                                if (chooseKeyword || chooseChat || chooseTipe) {
                                  console.log(chooseTipe);

                                  setChooseData([
                                    ...chooseData,
                                    {
                                      keyword: chooseKeyword || "",
                                      chat: chooseChat || "",
                                      tipe: chooseTipe || "",
                                      messageNext:
                                        chooseTipe == "text" ||
                                        chooseTipe == "attachment"
                                          ? messageNext
                                          : "",
                                      status: chooseStatus,
                                      messageStop:
                                        chooseStatus == "stop"
                                          ? messageStop
                                          : "",
                                    },
                                  ]);
                                  setChooseKeyword("");
                                  setChooseChat("");
                                  setChooseTipe("");
                                  setMessageNext("");
                                  setMessageStop("");
                                }
                              }}
                            >
                              Tambah
                            </button>
                          </div>
                          {(chooseTipe == "text" ||
                            chooseTipe == "attachment") && (
                            <div className="mb-3">
                              <label className="form-label">Message Next</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={messageNext}
                                onChange={(e) => setMessageNext(e.target.value)}
                              />
                            </div>
                          )}
                          {chooseStatus == "stop" && (
                            <div className="mb-3">
                              <label className="form-label">
                                Message Status Stop
                              </label>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={messageStop}
                                onChange={(e) => setMessageStop(e.target.value)}
                              />
                            </div>
                          )}
                          <div className="py-2">
                            <table className="table table-bordered table-sm mb-0">
                              <thead>
                                <tr>
                                  <th style={{ width: "80px" }} className="p-1">
                                    Keyword
                                  </th>
                                  <th className="p-1">Chat</th>
                                  <th className="p-1">Tipe</th>
                                  <th className="p-1">Message Next</th>
                                  <th className="p-1">Status</th>
                                  <th className="p-1">Message Stop</th>
                                  <th className="p-1" style={{ width: "40px" }}>
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {chooseData
                                  .slice()
                                  .sort((a, b) => {
                                    if (a.keyword < b.keyword) return -1;
                                    if (a.keyword > b.keyword) return 1;
                                    return 0;
                                  })
                                  .map((opt, idx) => (
                                    <tr key={idx}>
                                      <td className="text-center">
                                        {opt.keyword}
                                      </td>
                                      <td>{opt.chat ?? "-"}</td>
                                      <td>
                                        {opt.tipe == "keyword"
                                          ? "Sesuai Kata Kunci"
                                          : opt.tipe == "text"
                                          ? "Sesuai Teks"
                                          : opt.tipe == "attachment"
                                          ? "Sesuai Dokumen"
                                          : "-"}
                                      </td>

                                      <td>{opt.messageNext ?? "-"}</td>
                                      <td>
                                        {opt.status == "next"
                                          ? "Lanjut"
                                          : opt.status == "stop"
                                          ? "Berhenti"
                                          : opt.status == "loop"
                                          ? "Kembali"
                                          : "-"}
                                      </td>
                                      <td>{opt.messageStop ?? "-"}</td>

                                      <td className="text-center">
                                        <span
                                          className="text-danger"
                                          onClick={() =>
                                            setChooseData(
                                              chooseData
                                                .slice()
                                                .sort((a, b) => {
                                                  if (a.keyword < b.keyword)
                                                    return -1;
                                                  if (a.keyword > b.keyword)
                                                    return 1;
                                                  return 0;
                                                })
                                                .filter((_, i) => i !== idx)
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <Icon
                                            icon="mdi:trash"
                                            fontSize={"12pt"}
                                          />
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleClose}
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        // Pastikan chooses adalah array sebelum submit
                        const submitData = {
                          ...formData,
                          chooses: formData.type === "choose" ? chooseData : [],
                        };
                        setFormData(submitData);
                        // Gunakan submitData untuk addBot/update
                        if (isEdit) {
                          handleUpdate(formData.id, submitData);
                        } else {
                          addBot(submitData);
                        }
                      }}
                    >
                      {isEdit ? "Save Changes" : "Add Bot"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default BotPage;
